import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BifIconTableOrderDown, BifIconTableOrderUp } from "banafo-design-system";
import { SORT_ASC, SORT_DESC } from "src/app/config";
import "./SortableCol.scss";
const SortableCol = ({ children, sort, sortType }) => {
    return (_jsxs("span", { className: "sortable-col", onClick: sort, children: [children, sortType === SORT_ASC && _jsx(BifIconTableOrderDown, { className: "sort-down ms-50" }), sortType === SORT_DESC && _jsx(BifIconTableOrderUp, { className: "sort-up ms-50" })] }));
};
export default SortableCol;
